import {TemplateComponent} from './template-component';
import { User } from './user';

export interface TemplateComponentContentJSON {
  template_component_content_id: number;
  template_component_id: number;
  content: string;
  locale: string;
  product_id: string;
  sample_content: string;
  is_default_ind: boolean;
}

export class TemplateComponentContent {

  static parse(json: TemplateComponentContentJSON): TemplateComponentContent {
    const obj = new TemplateComponentContent();

    obj.id = json.template_component_content_id;
    obj.templateComponent = new TemplateComponent(json.template_component_id);
    obj.content = json.content;
    obj.locale = json.locale;
    obj.productId = json.product_id;
    obj.sampleContent = json.sample_content;
    obj.isDefaultInd = json.is_default_ind;

    return obj;
  }

  constructor(
    public id?: number,
    public templateComponent?: TemplateComponent,
    public content?: string,
    public locale?: string,
    public productId?: string,
    public sampleContent?: string,
    public isDefaultInd?: boolean,
    public date?: string,
    public user_id?: string,
    public username?: string,
    public template_name?: string,
    public template_id?: number,
    public template_component_name?: string,
    public areQuotesChanged?: boolean,
  ) {
  }

  toJSON() {
    const obj = {};

    for (const prop in this) {
      if (prop === 'id') {
        obj['template_component_content_id'] = this[prop];
      } else if (prop === 'templateComponent') {
        obj['template_component_id'] = this[prop]['id'];
      } else if (prop === 'productId') {
        obj['product_id'] = this[prop];
      } else if (prop === 'sampleContent') {
        obj['sample_content'] = this[prop];
      } else if (prop === 'isDefaultInd') {
        obj['is_default_ind'] = this[prop];
      } else {
        obj[prop.toString()] = this[prop];
      }
    }

    return obj;
  }

  clone(): TemplateComponentContent {
    return new TemplateComponentContent(this.id,
      this.templateComponent,
      this.content,
      this.locale,
      this.productId,
      this.sampleContent,
      this.isDefaultInd);
  }
}
